export default "__VITE_ASSET__497c238b__"